import loadScript from "@elements/load-script";
import {onEnterViewPort} from "@elements/viewport-utils";

export function init() {
    onEnterViewPort($('.js-walls-io'), function () {
        loadScript('https://walls.io/js/wallsio-widget-1.2.js');
    }, {offset: window.innerHeight * 1.1});
}